import { useCallback } from 'react';

// Types
import {
  QuestionType,
  QuestionTypeType,
  TextareaQuestionType,
  GifQuestionType,
  RatingQuestionType,
  RatingSummaryQuestionType,
  AdjectivesForPropertyQuestionType,
  AdjectivesForPropertySummaryQuestionType,
  RatingOptionType,
} from 'Shared/types/ReviewFormTemplate.type';

// Utils
import { getReviewTemplateQuestionErrors } from 'Shared/utils/ReviewFormTemplate.utils';

type Props = {
  question: QuestionType;
  onChange?: Function;
};

export const useQuestion = ({ question, onChange }: Props) => {
  const handleUpdateQuestion = useCallback(
    (values: {
      type?: QuestionTypeType;
      header?: string;
      description?: string;
      showExplanation?: boolean;
      explanationDescription?: string;
      values?: RatingOptionType[];
      property?: string;
      adjectives?: {
        negative: string[];
        positive: string[];
      };
      optional?: boolean;
      summarizedQuestionKey?: string;
    }) => {
      if (values?.type && values?.type !== question.type) {
        //   let newQuestion = (({ key, header, description }) => ({ key, header, description }))(question as Question);
        let newQuestion;
        switch (values.type) {
          case QuestionTypeType.HOLISTIC_SUMMARY:
          case QuestionTypeType.TEXTAREA:
            newQuestion = {
              key: question.key,
              type: values.type,
              header: question.header,
              description: question.description,
              placeholder: '',
            } as TextareaQuestionType;
            break;
          case QuestionTypeType.GIF:
            newQuestion = {
              key: question.key,
              type: QuestionTypeType.GIF,
              header: question.header,
              description: question.description,
            } as GifQuestionType;
            break;
          case QuestionTypeType.RATING_SUMMARY:
            newQuestion = {
              key: question.key,
              type: QuestionTypeType.RATING_SUMMARY,
              header: '',
              description: '',
              summarizedQuestionKey: values.summarizedQuestionKey,
            } as RatingSummaryQuestionType;
            break;
          case QuestionTypeType.ADJECTIVES_FOR_PROPERTY_SUMMARY:
            newQuestion = {
              key: question.key,
              type: QuestionTypeType.ADJECTIVES_FOR_PROPERTY_SUMMARY,
              header: '',
              description: '',
              summarizedQuestionKey: values.summarizedQuestionKey,
            } as AdjectivesForPropertySummaryQuestionType;
            break;
          case QuestionTypeType.ADJECTIVES_FOR_PROPERTY:
            newQuestion = {
              key: question.key,
              type: QuestionTypeType.ADJECTIVES_FOR_PROPERTY,
              header: 'Communication',
              description: 'What best describes their communication?',
              property: 'Communication',
              adjectives: {
                positive: ['authentic'],
                negative: ['disagreeable'],
              },
            } as AdjectivesForPropertyQuestionType;
            break;
          case QuestionTypeType.RATING:
            newQuestion = {
              key: question.key,
              type: QuestionTypeType.RATING,
              header: question.header,
              description: question.description,
              showExplanation: true,
              explanationDescription: 'Summarize why you chose that rating',
              values: [
                {
                  number: 1,
                  label: '',
                },
                {
                  number: 2,
                  label: '',
                },
                {
                  number: 3,
                  label: '',
                },
              ],
            } as RatingQuestionType;
            break;
        }
        onChange({ question: newQuestion });
      } else {
        onChange({ question: { ...question, ...values } });
      }
    },
    [question]
  );

  const errors = getReviewTemplateQuestionErrors({ question });

  return {
    handleUpdateQuestion,
    errors,
  };
};
